import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import {
    useBusinessRole,
    useCheckBusinessRoleAccessByAssignmentId,
    useTargetPerson,
} from 'hooks'
import BusinessRoleDetails from './BusinessRoleDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const BusinessRolesDrawer = ({ id, attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const { data: assignmentStatus } = useCheckBusinessRoleAccessByAssignmentId(
        id,
        targetPerson.id,
    )

    const { data: businessRole } = useBusinessRole(id, true)

    let item
    if (businessRole && assignmentStatus) {
        item = {
            resource: businessRole,
            assignment: assignmentStatus,
        }
    }

    const itemDetails = <BusinessRoleDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default BusinessRolesDrawer
